import { NavLink } from 'react-router-dom';

export const DropdownNavItem = ({ menu, ...props }) => {

    let label = menu.label && <span className="menu-label ms-5px">{menu.label}</span>;
    let highlight = menu.highlight && <i className="fa fa-paper-plane text-theme"></i>;
    let title = menu.title && <div className="menu-text">{menu.title} {label} {highlight}</div>;

    return (
        <NavLink className="dropdown-item" to={menu.path} {...props}>
            {title}
        </NavLink>
    );
}